import { required, helpers } from '@vuelidate/validators';

export const customRequired= helpers.withMessage('See väli on kohustuslik', required);

export {
  customRequired as required
};